export const BenefitsAndCreditsQuestions = {
  childBenefit: {
    titleKey: 'affordabilityCalculator.benefitsAndCredits.childBenefit.title',
  },
  universalTaxCredits: {
    titleKey: 'affordabilityCalculator.benefitsAndCredits.universalTaxCredits.title',
  },
  stateDisabilityAllowance: {
    titleKey: 'affordabilityCalculator.benefitsAndCredits.stateDisabilityAllowance.title',
  },
};
